









































import { Component, Vue } from 'vue-property-decorator';
import { userModule } from '@/vuex/modules/user';
import { hideOverlay } from '@/util/common/overlay';

/**
 * エラー画面.
 */
@Component({
  name: 'Error'
})
export default class Error extends Vue {
  private user = userModule;
  private cause: any = '';
  // リダイレクトフラグ
  // NOTE：TRUE = 画面描写しない / FALSE = 画面描写される
  private isRedirect: boolean = false;
  public async mounted(): Promise<void> {
    hideOverlay();
  }
  private created() {
    if (!this.user.isLoggedIn && this.$route.query.cause) {
      this.cause = this.$route.query.cause;
    }

    const redirected = this.$route.query.redirected;
    if (!redirected && !this.cause) {
      // リダイレクト後は、クエリパラメータ（rediredted）が設定されてるため、trueにならない
      this.isRedirect = true;
      window.location.href = `${process.env.VUE_APP_HOST_URL}redirect/error`;
    }
  }

  private async clickLogin() {
    // アプリの場合はクエリパラメーターにデバイストークンを付ける
    if (this.user.isMobile) {
      const mobileIdentifier = localStorage.getItem('mobileIdentifier');
      window.location.href = `${process.env.VUE_APP_HOST_URL}redirect/login?mobileIdentifier=` + mobileIdentifier;
    } else {
      window.location.href = `${process.env.VUE_APP_HOST_URL}redirect/login`;
    }
  }
}
